import { Input } from '@components/Component/Field/Input/Input.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
/**
 * Class `InputPassword` extends from the `Input` class.
 * It represents a password input field with visibility toggle functionality.
 */
export class InputPassword extends Input {
    constructor() {
        super(...arguments);
        this.componentName = 'InputPassword';
        this.icon = 'visibility';
        /** The type of the input. Defaults to 'password'. */
        this.inputType = 'password';
    }
    draw() {
        super.draw();
        this.inputElement.setAttribute('type', this.inputType);
        this.on('iconClick', () => this.togglePasswordVisibility());
    }
    /**
     * This method is used to toggle the visibility of the password.
     */
    togglePasswordVisibility() {
        const newType = this.inputType === 'password' ? 'text' : 'password';
        const newIcon = this.inputType === 'password' ? 'visibility_off' : 'visibility';
        this.icon = newIcon;
        this.inputType = newType;
        if (this.inputElement) {
            this.inputElement.setAttribute('type', newType);
        }
        if (this.iconElement) {
            DIContainer.getInstance('IconManager').updateIcon(this.iconElement, newIcon);
        }
    }
}
InputPassword.VERSION = '$Revision: 123499 $';
